var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { useGptStreamState } from '../hooks/use-gpt-stream-state';
import { classNames } from '@shapeable/utils';
import { GptPrompt } from './gpt-prompt';
import { useGpt } from '../hooks/use-gpt';
import { GptGeneratedContent } from './gpt-generated-content';
import { GptOutputHeader } from './gpt-output-header';
import { GptOutputItem } from './gpt-output-item';
var cls = classNames('entity-gpt-layout');
export var GptLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var PromptStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(75))
});
var ContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    margin-bottom: ", ";\n\n    \n  "], ["\n    padding: ", " ", " ", ";\n    margin-bottom: ", ";\n\n    \n  "])), theme.UNIT(2), theme.UNIT(4), theme.UNIT(6), theme.UNIT(75))
});
var PaddingStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    padding: ", ";\n    width: 100%;\n    justify-content: center;\n    box-sizing: border-box;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    padding: ", ";\n    width: 100%;\n    justify-content: center;\n    box-sizing: border-box;\n    margin-bottom: ", ";\n  "])), theme.UNIT(3), theme.UNIT(75))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Padding: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), PaddingStyles),
  Prompt: styled(GptPrompt)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), PromptStyles),
  Header: styled(GptOutputHeader)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Content: styled(GptGeneratedContent)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Item: styled(GptOutputItem)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles)
};
export var GptLayout = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var _a = useGpt({
      entity: entity
    }),
    isResponseLoading = _a.isResponseLoading,
    messages = _a.messages,
    activePrompt = _a.activePrompt,
    activeLanguage = _a.activeLanguage,
    cancelStream = _a.cancelStream;
  var _b = __read(useGptStreamState(), 1),
    gptStream = _b[0];
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, messages.map(function (message, i) {
    return React.createElement(My.Item, {
      key: "message-".concat(message.id),
      message: message
    });
  }), activePrompt && React.createElement(My.Header, {
    onStopClick: function () {
      cancelStream();
    },
    prompt: activePrompt,
    isPartial: true
  }), isResponseLoading && React.createElement(My.Padding, null), gptStream.answer && React.createElement(My.Content, {
    text: gptStream.answer,
    activeLanguage: activeLanguage
  }), !(isResponseLoading || gptStream.isStreaming) && React.createElement(My.Prompt, {
    entity: entity
  }));
};
GptLayout.defaultProps = GptLayoutDefaultProps;
GptLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;